import React, { useState } from "react";
import { BrowserRouter as Router, Navigate, Route, Routes } from "react-router-dom";
import "./App.css";
import CheckoutForm from "./components/CheckoutForm";
import ScrollToTop from "./components/ScrollToTop";
import About from "./pages/About";
import ClientResults from "./pages/ClientResults";
import ColourAnalysis from "./pages/ColourAnalysis";
import ContactPage from "./pages/Contact";
import GreyEnhancement from "./pages/GreyEnhancement";
import GreyTransition from "./pages/GreyTransition";
import Home from "./pages/Home";
import Login from "./pages/Login";
import Purchase from "./pages/Purchase";
import Register from "./pages/Register";
import Terms from "./pages/Terms";

const App = () => {
  const [authenticated, setAuthenticated] = useState(false);

  if (authenticated) {
    console.log("User authenticated");
  }

  return (
    <Router>
      <ScrollToTop />
      <Routes>
        <Route element={<Home />} index />
        <Route element={<GreyTransition />} path="the-grey-transition" />
        <Route element={<GreyEnhancement />} path="grey-enhancement" />
        <Route element={<ColourAnalysis />} path="colour-analysis" />
        <Route element={<About />} path="about-lizzie" />
        <Route element={<ClientResults />} path="client-results" />
        <Route element={<ContactPage />} path="contact" />
        <Route element={<Terms />} path="terms" />
        <Route element={<Navigate replace to="/terms" />} path="policies" />

        <Route element={<Navigate replace to="/about-lizzie" />} path="about" />
        <Route element={<Navigate replace to="/the-grey-transition" />} path="services" />
        <Route element={<Navigate replace to="/client-results" />} path="gallery" />
        <Route element={<Navigate replace to="/the-grey-transition" />} path="prices" />
        <Route element={<Navigate replace to="/grey-enhancement" />} path="the-grey-enhancement" />
        <Route
          element={<Navigate replace to="/the-grey-transition" />}
          path="grey-blending-handbook"
        />
        <Route element={<Navigate replace to="/the-grey-transition" />} path="olaplex" />
        <Route element={<Navigate replace to="/" />} path="products" />

        <Route element={<Purchase />} path="purchase" />
        <Route element={<Login />} path="login" />
        <Route element={<Register />} path="register" />
        <Route
          element={<CheckoutForm setAuthenticated={setAuthenticated} />}
          path="checkout"
        />

        <Route element={<Navigate replace to="/" />} path="*" />
      </Routes>
    </Router>
  );
};

export default App;
